import React, { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const FluentEdit: FC<{ fillColor?: string } & SvgProps> = ({
  fillColor = '#212121',
  ...props
}) => (
  <Svg width={24} height={24} fill='none' viewBox='0 0 24 24' {...props}>
    <Path
      d='M21.03 2.97a3.578 3.578 0 010 5.06L9.062 20a2.25 2.25 0 01-.999.58l-5.116 1.395a.75.75 0 01-.92-.921l1.395-5.116a2.25 2.25 0 01.58-.999L15.97 2.97a3.578 3.578 0 015.06 0zM15 6.06L5.062 16a.75.75 0 00-.193.333l-1.05 3.85 3.85-1.05A.75.75 0 008 18.938L17.94 9 15 6.06zm2.03-2.03l-.97.97L19 7.94l.97-.97a2.079 2.079 0 00-2.94-2.94z'
      fill={fillColor}
    />
  </Svg>
)
export default FluentEdit
